import {
    type AnalyticsClientInterface,
    type AnalyticsDateRangeParam,
    axiosCacheInterceptorRequestConfig,
} from './analyticsClient.types';
import BaseClient, { type BaseClientConfig } from '../BaseClient';

export default class OrgUnitAnalyticsClient extends BaseClient implements AnalyticsClientInterface {
    constructor(private teamId: number, private orgUnitId: number, config: BaseClientConfig = {}) {
        super(config);
    }

    getMarketingSubscriptionsTotalByStatus() {
        const url = `${this.apiBase}/teams/${this.teamId}/org-units/${this.orgUnitId}/statistics/current/contacts/total-preferred-by-subscription-status`;
        return this.makeCoreApiRequest(url, 'post', null, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptIns(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/org-units/${this.orgUnitId}/statistics/time-series/contacts/total-preferred-opt-ins`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getMarketingSubscriptionsTotalOptOuts(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/org-units/${this.orgUnitId}/statistics/time-series/contacts/total-preferred-opt-outs`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getContactsTotalCreated(params: AnalyticsDateRangeParam) {
        const url = `${this.apiBase}/teams/${this.teamId}/org-units/${this.orgUnitId}/statistics/time-series/contacts/total-preferred-created`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }
}
